import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export function formatFilterDuration(value, op) {
	if (!value) return null;

	let prefix = '';
	let string = '';

	const d = dayjs.duration(value);

	if (op === 'gtDate') {
		prefix = '>';
	}

	if (op === 'ltDate') {
		prefix = '<';
	}

	if (d.years()) string = `${d.years()} лет`;
	if (d.months()) string = `${d.months()} месяца(ев)`;
	if (d.weeks()) string = `${d.weeks()} недель`;
	if (d.days()) string = `${d.days()} дней`;
	if (d.hours()) string = `${d.hours()} часов`;
	if (d.minutes()) string = `${d.minutes()} минут`;
	if (d.seconds()) string = `${d.seconds()} секунд`;

	string = `${prefix} ${string} назад`.trim();

	return string || null;
}
